import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFileInvoice } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { memo, useCallback } from 'react';

interface SelectionToolbarProps {
  selectedCount: number;
  onClose: () => void;
  onCreatePreInvoice: () => void;
  isCreating?: boolean;
}

export const SelectionToolbar = memo(
  ({ selectedCount, onClose, onCreatePreInvoice, isCreating = false }: SelectionToolbarProps) => {
    const { t } = useTranslation('eligibleStorageModule');

    const handleClose = useCallback(() => {
      onClose();
    }, [onClose]);

    const handleCreate = useCallback(() => {
      onCreatePreInvoice();
    }, [onCreatePreInvoice]);

    if (selectedCount === 0) {
      return null;
    }

    return (
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
        <div className="bg-card-bg border border-card-border rounded-lg p-2 shadow-lg">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 bg-primary text-white text-sm rounded-full flex items-center justify-center">
                {selectedCount}
              </span>
              <span className="text-sm font-medium">{t('selection.selected')}</span>
            </div>

            <Button
              variant="primary"
              size="sm"
              onClick={handleCreate}
              disabled={isCreating}
              className="gap-2 text-white"
            >
              <FontAwesomeIcon icon={faFileInvoice} className="w-3 h-3" />
              {isCreating ? t('selection.creating') : t('selection.createPreInvoice')}
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={handleClose}
              className="p-0 hover:bg-transparent"
              disabled={isCreating}
            >
              <FontAwesomeIcon icon={faTimes} className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    );
  },
);

SelectionToolbar.displayName = 'SelectionToolbar';
